import { store, getContext, getConfig } from "@wordpress/interactivity";

const decodeEntities = (str = "") =>
	new DOMParser().parseFromString(str, "text/html").documentElement.textContent;

const NAMESPACE = "mgblocks/blog-archive";

const { state, actions } = store(NAMESPACE, {
	state: {
		get isLastPage() {
			return state.maxNumPages ? state.page >= state.maxNumPages : false;
		},
		get loadButtonText() {
			const { translations } = getConfig();
			return state.isLoading ? translations.loading : translations.loadMore;
		},
		get currentCount() {
			return state.posts.length;
		},
		get hasPosts() {
			if (!state.isActive) return true;
			return state.posts.length > 0;
		},
	},
	actions: {
		*loadMore() {
			state.page += 1;
			yield actions.fetchPosts();
		},
		*fetchPosts(url = "") {
			const { restApiUrl } = getConfig();
			state.isLoading = true;

			try {
				let categories = state.filters.categories?.join() || "";
				let post_types = state.filters.post_type?.join() || "";
				if (
					state.selectedCategories?.length &&
					state.selectedCategories?.length > 0
				) {
					categories = state.selectedCategories.join();
				}

				const fetchUrl = `${restApiUrl}/?post_type=${post_types}&page=${
					state.page
				}&offset=${state.offset}&posts_per_page=${
					state.postsPerPage
				}&categories=${categories}&s=${state?.searchTerm || ""}`;

				if (!url) {
					url = fetchUrl;
				}

				const res = yield fetch(url);
				if (!res.ok) {
					throw new Error(`Archive fetch failed: ${res.status}`);
				}
				const data = yield res.json();

				state.maxNumPages = data.maxNumPages;
				state.totalCount = data.totalCount;

				const decodedPosts = data.posts.map((post) => ({
					...post,
					title: decodeEntities(post.title),
				}));
				if (state.page === 1) {
					state.posts = decodedPosts;
				} else {
					state.posts = [...state.posts, ...decodedPosts];
				}
			} catch (err) {
				console.log(err);
			} finally {
				state.isLoading = false;
			}
		},
		*clearAllFilters() {
			state.selectedCategories = [];
			state.searchTerm = "";
			state.page = 1;
			yield actions.fetchPosts();
		},
	},
	callbacks: {
		*loadInitialPosts() {
			// console.log("object", JSON.parse(JSON.stringify(state.filters)));
			yield actions.fetchPosts();
			state.isActive = true;
		},
	},
});
